import React from "react";
import { Link, useParams } from "react-router-dom";
// import banner from "./images/Blog-banner.png";
import BlogsForm from "./blogsform";

import { type } from "@testing-library/user-event/dist/type";
import { assets } from "../assets/assets";

const latestnewsdetails = [
  {
    id: 1,
    title:
      "Empower Your Organization in Achieving Gold Standard of Auditable ESG Data with AccelTRACK",
    //   subtitle: "by admin | April 5, 2024 | Event | 0 comments",
    // image: assets.ListedCompanies2,
    bannerImage: assets.ListedCompanies2,
    description: [
      {
        type: "h2",
        content: "Join Us for the Webinar",
      },
      {
        type: "p",
        content: "April 5th 2024, 9:00 AM EST",
      },
      {
        type: "button",
        content: "Register Now",
        link: "https://your-registration-link.com", // Replace this with actual registration URL
      },
      {
        type: "h3",
        content: "About the Event",
      },
      {
        type: "p",
        content:
          "We’re thrilled to invite you to an exclusive webinar hosted by Accel1, where we’ll unveil our latest innovation: AccelTRACK – a cutting-edge, cloud-based ESG reporting solution. Join us on 5th April 2024 to discover how AccelTRACK will revolutionize the way your organization approaches sustainability reporting. During this webinar, we’ll delve into insights and practical knowledge that can significantly benefit your sustainability efforts, focusing on how AccelTRACK seamlessly maps your initiatives to various ESG frameworks. Don’t miss this opportunity to learn firsthand how AccelTRACK can streamline your ESG data management processes and drive meaningful change. Reserve your spot today and secure your organization’s path towards a more sustainable future.",
      },
      {
        type: "h3",
        content: "Agenda",
      },
      {
        type: "ul",
        content: [
          {
            bold: "1. Introduction to AccelTRACK:",
            text: " Learn about the features and capabilities of AccelTRACK, our innovative cloud-based ESG reporting solution. Discover how AccelTRACK is designed to revolutionize the way organizations approach sustainability reporting.",
          },
          {
            bold: "2. Mapping Sustainability Efforts to ESG Frameworks:",
            text: " Explore how AccelTRACK seamlessly maps your sustainability initiatives to various ESG frameworks. Understand the importance of aligning your reporting with industry standards and best practices.",
          },
          {
            bold: "3. Live Demo of AccelTRACK:",
            text: " Witness a live demonstration of AccelTRACK in action, showcasing its intuitive interface and powerful reporting functionalities. See firsthand how AccelTRACK can streamline your ESG data collection, analysis, and reporting processes.",
          },
          {
            bold: "4. Interactive Q&A Session:",
            text: " Engage with our experts during a live Q&A session where you can ask questions and gain further insights into AccelTRACK and ESG reporting.",
          },
        ],
      },
    ],
  },
];

const LatestNewsDetails = () => {
  const { id } = useParams();
  const event = latestnewsdetails.find((event) => event.id === parseInt(id));

  if (!event) {
    return <div>event not found</div>;
  }

  return (
    <>
      <div className="innerbanner-section-1">
        <div className="relative-2">
          <div className="s2-heading-text">
            <h1 data-aos="zoom-in">Events</h1>
          </div>
          <img
            src={assets.careerbanner}
            alt=""
            data-aos="fade-in"
            className="d-d"
          />
          <img
            src={assets.careerbanner2}
            alt=""
            data-aos="fade-in"
            className="m-d"
          />
        </div>
      </div>

      <div className="wrapper blog-inner">
        {/* Banner Image */}
        <div className="banner">
          <h1>{event.title}</h1>
          <p>{event.subtitle}</p>
          <img
            src={event.bannerImage}
            alt={`${event.title} Banner`}
            className="banner-image"
          />
        </div>

        {/* event Content */}
        <div className="content">
          <div>
            {event.description.map((item, index) => {
              if (item.type === "p") {
                return <p key={index}>{item.content}</p>;
              } else if (item.type === "h2") {
                return <h2 key={index}>{item.content}</h2>;
              } else if (item.type === "h3") {
                return <h3 key={index}>{item.content}</h3>;
              } else if (item.type === "ul") {
                return (
                  <ul key={index}>
                    {item.content.map((listItem, idx) => (
                      <li key={idx}>
                        {typeof listItem === "object" ? (
                          listItem.bold ? (
                            <strong>{listItem.text}</strong>
                          ) : (
                            listItem.text
                          )
                        ) : (
                          listItem
                        )}
                      </li>
                    ))}
                  </ul>
                );
              } else if (item.type === "quote") {
                return (
                  <blockquote
                    key={index}
                    style={{ fontStyle: "italic", margin: "20px 0" }}
                  >
                    {item.content}
                  </blockquote>
                );
              } else if (item.type === "image") {
                return (
                  <div
                    key={index}
                    style={{ textAlign: "center", margin: "20px 0" }}
                  >
                    <img
                      src={item.src}
                      alt={item.title}
                      style={{ maxWidth: "100%" }}
                    />
                    <p style={{ fontStyle: "italic" }}>{item.title}</p>
                  </div>
                );
              }
              return null;
            })}
          </div>

          <BlogsForm />

          <Link to="/resources/events" className="backtoblog">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
            >
              <path
                d="M20.2376 13.0719L7.98975 13.2992L13.3363 18.4509L12.6903 19.213L6.0708 12.8347L12.4491 6.21525L13.1229 6.95288L7.9712 12.2994L20.2191 12.0721L20.2376 13.0719Z"
                fill="#B09955"
              />
            </svg>
            Back to Event Page
          </Link>
        </div>
      </div>
    </>
  );
};

export default LatestNewsDetails;
